import moengage from "@moengage/web-sdk";
import moment from "moment";
import environment from "src/constants/environment";

const moEngageUtils = {
  initialize: () => {
    try {
      moengage?.initialize({
        app_id: environment.MOENGAGE_APP_ID as string,
        cluster: environment.MOENGAGE_DATA_CENTER as string,
        debug_logs: parseInt(environment.MOENGAGE_ENABLE_DEBUG_LOGS ?? "0"),
      });
    } catch (error) {
      console.error("Error while initializing moengage:", error);
      //throw error;
    }
  },

  trackEvent: (eventName: string, eventData = {}) => {
    try {
      moengage?.track_event(eventName, eventData);
    } catch (error) {
      console.error("Error while tracking event:", error);
      //throw error;
    }
  },

  setUserAttributes: (attributes: any) => {
    try {
      const {
        dob,
        contactNo,
        contact_no,
        gender,
        name,
        paidUser: paid_user,
        patientID: patient_id,
        planName: plan_name,
        country_code = "+91",
        email = "",
        indication = "",
        dr_name = "",
        dr_phone = "",
        language = "",
        severity = "",
        medical_condition_name = "",
        height = "",
        height_unit = "",
        weight = "",
        weight_unit = "",
        patient_meta_info = null,
      } = attributes;

      const mobileNumber = contact_no || contactNo;

      //   Basic User Attributes
      const sanitizedCountryCode = country_code.startsWith("+")
        ? country_code.slice(1)
        : country_code;
      moengage?.add_unique_user_id(sanitizedCountryCode + mobileNumber);
      if (name) moengage?.add_user_name(name);
      if (mobileNumber) moengage?.add_mobile(mobileNumber);
      if (gender)
        moengage?.add_gender(
          gender === "M" ? "Male" : gender === "F" ? "Female" : ""
        );
      if (dob) moengage?.add_birthday(moment(dob).toDate());
      if (email) moengage?.add_email(email);

      // Patient Specific Attributes
      if (patient_id) moengage?.add_user_attribute("patient_id", patient_id);
      if (paid_user)
        moengage?.add_user_attribute(
          "paid_user",
          paid_user === 1 ? "Paid" : "Free"
        );
      if (plan_name) moengage?.add_user_attribute("plan_name", plan_name);

      if (indication) moengage?.add_user_attribute("indication", indication);
      if (dr_name) moengage?.add_user_attribute("dr_name", dr_name);
      if (dr_phone) moengage?.add_user_attribute("dr_phone", dr_phone);
      if (language) moengage?.add_user_attribute("language", language);
      if (severity) moengage?.add_user_attribute("severity", severity);
      if (medical_condition_name)
        moengage?.add_user_attribute(
          "medical_condition_name",
          medical_condition_name
        );

      //   Height and Weight Attributes
      if (height && height_unit)
        moengage?.add_user_attribute("height", `${height} ${height_unit}`);
      if (weight && weight_unit)
        moengage?.add_user_attribute("weight", `${weight} ${weight_unit}`);

      console.log("patient_meta_info", patient_meta_info);

      // Patient Meta Info Attributes
      if (patient_meta_info?.support_program_key)
        moengage?.add_user_attribute(
          "support_program_key",
          patient_meta_info?.support_program_key
        );
      if (patient_meta_info?.support_program_type)
        moengage?.add_user_attribute(
          "support_program_type",
          patient_meta_info?.support_program_type
        );

      // Caregiver Attributes
      moengage?.add_user_attribute(
        "user_type",
        patient_meta_info?.user_type || "patient"
      );
      if (patient_meta_info?.cg_name)
        moengage?.add_user_attribute(
          "caregiver_name",
          patient_meta_info?.cg_name
        );
      if (patient_meta_info?.cg_relation)
        moengage?.add_user_attribute(
          "caregiver_relation",
          patient_meta_info?.cg_relation
        );
      if (patient_meta_info?.cg_contact_no)
        moengage?.add_user_attribute(
          "caregiver_contact_no",
          patient_meta_info?.cg_contact_no
        );
    } catch (error) {
      console.error("Error while setting user attributes:", error);
      //throw error;
    }
  },

  logout: async () => {
    try {
      await moengage?.destroy_session();
    } catch (error) {
      console.error("Error while logging out:", error);
      //throw error;
    }
  },
};

export default moEngageUtils;
